import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    Button,
    Col,
    ControlLabel,
    Glyphicon,
    Panel,
    Row,
    Tab,
    Tabs
} from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import Select from "react-select";

import {
    quizGetByKey,
    quizCreate,
    quizPartnerCreate,
    quizPartnerDelete,
    quizUpdate,
} from "../../../../../api/cp";
import { useEventContext } from "../../../../context";
import { PagesProvider, usePagesContext } from "../../PagesSettings/context/PagesContext";
import { Event } from "../../../Comet";

import Loading from "../../../Loading";
import QuizPreview from "../QuizPreview";

import EditPartnersTab from "./Tabs/EditPartnersTab";
import EditFinalScreenTab from "./Tabs/EditFinalScreenTab";
import EditDisplayTab from "./Tabs/EditDisplayTab";
import EditQuestionsTab from "./Tabs/EditQuestionsTab";
import EditViewTab from "./Tabs/EditViewTab";
import QuizFinalScreenPreview from "../QuizFinalScreenPreview";

const QuizEditorPage = ({ event, onClose }) => {
    const { pages } = usePagesContext();
    const { quizId } = useParams();
    const [quiz, setQuiz] = useState({
        polls: [],
        partners: [],
    });
    const [isSaving, setSaving] = useState(false);
    const [pollPanelIndex, setPollPanelIndex] = useState(0);
    const [previewLocale, setPreviewLocale] = useState('ru');
    const [activeTab, setActiveTab] = useState('main');

    const previewLocaleOptions = [
        { value: 'ru', label: 'Ru' },
        { value: 'en', label: 'En' },
    ];

    const streamOptions = event.stream?.map((stream) => ({ value: String(stream.id), label: stream.description_ru || stream.description_en }));
    const pagesOptions = (pages || []).filter(page => page.path).map((page) => ({ value: page.path, label: page.titleRu || page.titleEn }));
    const quizPage = (pages || []).find(({ template }) => template === 'quiz');
    const pageBackgroundColor = "#" + event.moduleTheme?.backgroundColor;
    const pageBackgroundUrl = quizPage?.settings?.backgroundUrl || null;

    const getProperty = (name, defaultValue = '') => {
        return quiz.hasOwnProperty(name) ? quiz[name] : defaultValue;
    }

    const setProperty = (name, value) => {
        setQuiz({ ...quiz, [name]: value });
    }

    useEffect(async () => {
        if (!quizId) {
            setQuiz(null);
            return;
        }

        try {
            const quiz = await quizGetByKey(quizId);
            setQuiz({ ...quiz, backgroundColor: quiz.backgroundColor || '888888' });
            setPollPanelIndex(0);
        } catch (e) {
            console.error(e);
            setQuiz(null);
        }
    }, [quizId]);

    const saveQuiz = async (data) => {
        setSaving(true);
        try {
            let _quiz;
            if (getProperty('id')) {
                if (Array.isArray(data)) {
                    const responses = await Promise.all(data.map(async (datum) => {
                        const response = await quizUpdate(getProperty('id'), datum);
                        return response
                    }));
                    _quiz = responses[responses.length - 1];
                } else {
                    _quiz = await quizUpdate(getProperty('id'), data);
                }
            } else {
                _quiz = await quizCreate(event.eventKey, { ...data, backgroundColor: data.backgroundColor || '888888' });
            }
            setQuiz({ ..._quiz, backgroundColor: _quiz.backgroundColor || '888888' });
        } catch (e) {
            console.error(e);
        }
        setSaving(false);
    }

    const saveProperty = async (name, value) => {
        await saveQuiz({ [name]: value });
    }

    const saveProperties = async (arr) => {
        await saveQuiz(arr);
    }

    const savePropertyFile = async (name, file) => {
        const formData = new FormData();
        formData.append(name, file);
        await saveQuiz(formData);
    }

    const onQuizUpdate = (data) => {
        if (getProperty('id') !== data.id) {
            return;
        }

        setQuiz(Object.assign({}, quiz, data));
    }
    const onQuizDelete = (quiz) => {
        if (getProperty('id') !== quiz.id) {
            return;
        }
        onClose();
    }

    const createPartner = async () => {
        try {
            const partner = await quizPartnerCreate(getProperty('id'), {});
            setProperty('partners', [...getProperty('partners'), partner]);
        } catch (e) {
            console.error(e);
        }
    }

    const deletePartner = async (partnerId) => {
        try {
            await quizPartnerDelete(partnerId);
            setProperty('partners', getProperty('partners').filter(({ id }) => id !== partnerId));
        } catch (e) {
            console.error(e);
        }
    }


    if (!quiz) {
        return <Loading>Загрузка квиза</Loading>
    }


    return (
        <>
            <Event event={'create:quiz'} handler={(quiz) => onQuizUpdate(quiz)} />
            <Event event={'update:quiz'} handler={(quiz) => onQuizUpdate(quiz)} />
            <Event event={'delete:quiz'} handler={(quiz) => onQuizDelete(quiz)} />

            <Row>
                <Col xs={12}>
                    <Button onClick={onClose}>
                        <Glyphicon glyph="menu-left" />
                        {' '}Вернуться к списку
                    </Button>
                </Col>
            </Row>
            <div>&nbsp;</div>

            <Row>
                <Col xs={6}>
                    <Panel>
                        <PanelHeading>
                            <PanelTitle>Предпросмотр</PanelTitle>
                        </PanelHeading>
                        <PanelBody>
                            <Row>
                                <Col xs={2}>
                                    <ControlLabel>Язык</ControlLabel>
                                    <Select
                                        value={previewLocaleOptions.find(({ value }) => value === previewLocale)}
                                        options={previewLocaleOptions}
                                        onChange={({ value }) => setPreviewLocale(value)}
                                    />
                                </Col>
                            </Row>
                            <div>&nbsp;</div>
                            <div style={{
                                backgroundColor: pageBackgroundColor,
                                backgroundImage: `url(${pageBackgroundUrl})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                padding: '2rem',
                                height: 500
                            }}>
                                {activeTab === "finalScreen" ?
                                    <QuizFinalScreenPreview quiz={quiz} locale={previewLocale} /> :
                                    <QuizPreview quiz={quiz} locale={previewLocale} />
                                }
                            </div>
                        </PanelBody>
                    </Panel>
                </Col>
                <Col xs={6}>
                    <Tabs id="quiz-settings-tabs" onSelect={(tab) => setActiveTab(tab)}>
                        <Tab eventKey={'main'} title="Вид">
                            <p>&nbsp;</p>
                            <EditViewTab
                                getProperty={getProperty}
                                setProperty={setProperty}
                                saveProperty={saveProperty}
                                savePropertyFile={savePropertyFile}
                                isSaving={isSaving}
                            />
                        </Tab>
                        <Tab eventKey={'polls'} title="Вопросы">
                            <p>&nbsp;</p>
                            <EditQuestionsTab
                                quiz={quiz}
                                getProperty={getProperty}
                                setProperty={setProperty}
                                pollPanelIndex={pollPanelIndex}
                                setPollPanelIndex={setPollPanelIndex}
                            />
                        </Tab>
                        <Tab eventKey={'partners'} title="Партнёры">
                            <p>&nbsp;</p>
                            <EditPartnersTab
                                partners={getProperty('partners')}
                                quiz={quiz}
                                onCreate={createPartner}
                                onDelete={deletePartner}
                            />
                        </Tab>
                        <Tab eventKey={'finalScreen'} title="Последний экран">
                            <p>&nbsp;</p>
                            {!!getProperty('finalScreen') && <EditFinalScreenTab
                                quizId={quizId}
                                isSaving={isSaving}
                                finalScreen={getProperty('finalScreen')}
                                setProperty={(name, value) => setProperty('finalScreen', { ...getProperty('finalScreen'), [name]: value })}
                                onSave={(key, value) => saveProperty('finalScreen', { ...getProperty('finalScreen'), [key]: value })}
                            />}
                        </Tab>
                        <Tab eventKey={'displaySetting'} title="Настройка отображения">
                            <p>&nbsp;</p>
                            <EditDisplayTab
                                getProperty={getProperty}
                                setProperty={setProperty}
                                saveProperty={saveProperty}
                                saveProperties={saveProperties}
                                isSaving={isSaving}
                                streamOptions={streamOptions}
                                pagesOptions={pagesOptions}
                            />
                        </Tab>
                    </Tabs>
                </Col>
            </Row >
        </>
    )
}

export default ({ onClose }) => {
    const { event } = useEventContext();

    return (
        <PagesProvider
            event={event}
            setPagesLoaded={() => { }}
        >
            <QuizEditorPage onClose={onClose} event={event} />
        </PagesProvider>
    );
}
